var FOCUSABLES = [
    "a[href]:not([tabindex='-1'])",
    "area[href]:not([tabindex='-1'])",
    "input:not([disabled]):not([tabindex='-1'])",
    "select:not([disabled]):not([tabindex='-1'])",
    "textarea:not([disabled]):not([tabindex='-1'])",
    "button:not([disabled]):not([tabindex='-1'])",
    "iframe:not([tabindex='-1'])",
    "[tabindex]:not([tabindex='-1'])",
    "[contentEditable=true]:not([tabindex='-1'])"
];
var selector = FOCUSABLES.join(', ');
export function getFocusables(root, focusablesSelector) {
    if (focusablesSelector === void 0) { focusablesSelector = selector; }
    var selected = Array.from(root.querySelectorAll(focusablesSelector));
    return selected.filter(visible);
}
function visible(elem) {
    return !!(elem.offsetWidth || elem.offsetHeight);
}
